import React, {SFC, useState} from "react";
import {Typography, Box, useMediaQuery, makeStyles, Grid, GridItemsAlignment, Button} from "@material-ui/core";
import {Link} from "react-router-dom";

import RemovePet from "../../Modals/RemovePet";
import {ReactComponent as LogoSVG} from "../../../Images/addPetIcon.svg";
import {colorError, colorInputBorder, colorInputBorderGrayish} from "../../../Constants/theme";
import {useTheme} from "@material-ui/core/styles";
import {setSelectedAnimal} from "../../../redux/pets/pets.actions";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {setPetType} from "../../../utils/petInfo";
import {createPetTypeIconLookup} from "../../../utils/petTypeIcons";
import {paddingRight} from "html2canvas/dist/types/css/property-descriptors/padding";

interface Props {
    id: number,
    type: "dog" | "cat" | string,
    name: string,
    gender?: string,
    breed?: string,
    imageUrl?: string,
    birthday?: string,
}

const useStyle = makeStyles(() => ({
    itemContainer: {
        borderBottom: `1px solid ${colorInputBorderGrayish}`
    },
    avatarWrapper: {
        margin: "0 auto",
        marginBottom: 10,
    },
    button: {
        padding: "12px 44px"
    }
}));

const PetsListItem: SFC<Props> = ({type, id, gender, breed, birthday, imageUrl, name}: Props) => {
    const [isRemoveModalVisible, setIsRemoveModalvisible] = useState(false);
    const [actualImageUrl, setActualImageUrl] = useState(imageUrl);
    const pets = useSelector((state: RootState) => state?.pets.petsList);
    const dispatch = useAppDispatch();
    const classes = useStyle();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const alignmentResponsive: GridItemsAlignment = isMobile ? "center" : "flex-start";
    const branding = useSelector((state: RootState) => state?.branding);
    const setSelectedPet = (id) => {
        const pet = pets.find(item => item.id === id);
        dispatch(setSelectedAnimal(pet));
    };

    return (
        <Box
            paddingY="40px"
            padding="40px"
        >
            <Grid container spacing={4} className={classes.itemContainer}>
                <Grid container item xs={12} sm={2} alignItems={alignmentResponsive} justify="center">
                    <Box
                        marginBottom={isMobile ? "30px" : "0"}
                    >
                        {
                            actualImageUrl ?
                                <img alt="pet image" src={imageUrl} style={{borderRadius: "4px", objectFit: "cover"}} width="100"
                                    height="100" onError={() => {
                                        setActualImageUrl("");
                                    }}/>
                                :
                                // Using vanilla js object and select by the key, so we could switch i
                                !isWhiteLabel
                                    ?
                                    createPetTypeIconLookup()[setPetType(type)] ||
                                            <LogoSVG/>
                                    :
                                    <Box display="flex" justifyContent="center" alignItems="center"
                                        width="100px" height="100px">
                                        <img
                                            alt="brand logo"
                                            src={branding.logo}
                                            width="100%"
                                        />
                                    </Box>

                        }
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box display="flex" flexDirection="column" alignItems={alignmentResponsive} justifyContent="center">
                        <Box marginBottom="10px">
                            <Typography variant="h4"
                                style={{textTransform: "capitalize", whiteSpace: "break-spaces", wordBreak: "break-word", paddingRight: !isMobile ? "40px" : "0px"}}>
                                {name}
                            </Typography>
                        </Box>
                        <Typography autoCapitalize=""
                            color="textSecondary" style={{
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            wordBreak: 'break-word',
                        }}>{gender && gender.toProperCase()}{breed && <>, {breed}</>}</Typography>
                    </Box>
                </Grid>
                <Grid item container justify={isMobile ? "center" : "flex-end"} xs={12} sm={4}>
                    <Link to={`pets/${id}`} style={{textDecoration: "none"}}>
                        <Button type="button" variant="contained" color="primary" className={classes.button}
                            onClick={setSelectedPet.bind(null, id)}
                        >
                            View
                        </Button>
                    </Link>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PetsListItem;
